import { useQuery } from '@hooks/reactQuery';

import { auth } from '@store/selectors';
import { useAppSelector } from '@store/store';

import { getAcquiredAssetOwners } from '@api/manageAcquiredAssets';

import { optionsFormattedWithIdName } from '@utils/formatter';

import { IAssetOwner } from '@interfaces/assets/asset';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { MANAGE_ACQUIRE_ASSETS_ASSET_OWNERS } from '@constants/queryKeys';

export const useQueryAcquiredAssetOwners = () => {
	const {
		accessPermission: {
			networkOperatorOrganizationAdministrator,
			networkOperatorAssetViewer,
			networkOperatorAssetEnquirer,
			assetConsumerOrganizationAdministrator,
			assetConsumerAssetEnquirer,
			assetConsumerAssetViewer,
		},
	} = useAppSelector(auth);

	const haveAccessToAcquiredAssets = (
		networkOperatorOrganizationAdministrator ||
		networkOperatorAssetViewer ||
		networkOperatorAssetEnquirer ||
		assetConsumerOrganizationAdministrator ||
		assetConsumerAssetEnquirer ||
		assetConsumerAssetViewer
	);

	const {
		data: assetOwners,
		isInitialLoading,
	} = useQuery({
		queryKey: [MANAGE_ACQUIRE_ASSETS_ASSET_OWNERS],
		queryFn: getAcquiredAssetOwners,
		select: (assetOwners: Array<IAssetOwner>) => optionsFormattedWithIdName(assetOwners),
		enabled: [haveAccessToAcquiredAssets],
		allowedRoles: [
			EUserRoles.networkOperatorAssetEnquirer,
			EUserRoles.networkOperatorAssetViewer,
			EUserRoles.assetConsumerAssetEnquirer,
			EUserRoles.assetConsumerAssetViewer,
		],
		...refetchOptions,
	});

	return {
		assetOwners: assetOwners || [],
		isLoadingAssetOwners: isInitialLoading,
	};
};
